import React from "react";
import { Box } from "../elements/Box";

export function CardLayout({ className = undefined, children = undefined, style = undefined, onClick = undefined }) {
  return (
    <Box onClick={onClick} style={style} className={`mc-card ${className ? className : ""}`}>
      {" "}
      {children}
    </Box>
  );
}
